import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { CONTATO_DISPARO_FILTRO_SESSION_KEY, ROTA_TELA_CONTATOS } from '../util/chat-transferencia.constants';

@Injectable({ providedIn: 'root' })
export class AberturaContatoService {
  private readonly router = inject(Router);
  private readonly pedidos = new Subject<void>();
  readonly pedidos$ = this.pedidos.asObservable();

  abrir(numero: string): void {
    sessionStorage.setItem(CONTATO_DISPARO_FILTRO_SESSION_KEY, numero);
    if (this.router.url.split('?')[0] === ROTA_TELA_CONTATOS) {
      this.pedidos.next();
      return;
    }
    this.router.navigate([ROTA_TELA_CONTATOS]);
  }
}
